import { render, staticRenderFns } from "./NavigationalAidsLayer.vue?vue&type=template&id=87df352a"
import script from "./NavigationalAidsLayer.vue?vue&type=script&lang=js"
export * from "./NavigationalAidsLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports